import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { WarrantyPage } from "src/routes/warranty/WarrantyPage";
import { WarrantyTicketPage } from "src/routes/warranty/WarrantyTicketPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { warrantyDetailsRoute, warrantyRoute } from "src/routing/domains/warrantyPaths";

/**
 * `/warranty/*` route tree.
 *
 * Role: data router domain route.
 *
 * Two layout stacks coexist during migration:
 * - **New (Beam):** `AppShell` → `BeamNavbarLayout` → page (list using `PageHeaderLayout`)
 * - **Legacy:** `AppShell` → `GlobalNavLayout` → page (ticket detail owns its own scroll/layout)
 *
 * Path constants live in `warrantyPaths.ts` (imported by `RouteUrls.ts` / pages) to avoid a cycle
 * through this file's page `Component` imports.
 */
const warrantyDomainRoute: RouteObject = {
  path: warrantyRoute.path,
  Component: AppShell,
  children: [
    { Component: BeamNavbarLayout, children: [{ index: true, Component: WarrantyPage }] },
    {
      Component: GlobalNavLayout,
      children: [{ path: `${warrantyDetailsRoute.path}/*`, Component: WarrantyTicketPage }],
    },
    { path: "*", Component: NotFound },
  ],
};

/**
 * Migrated `/warranty/*` route trees registered in `Router.tsx`.
 */
export const warrantyRoutes = [warrantyDomainRoute];
